/**
 * DESERTLAND.Content.Learnmore
 */
import { Utils } from '../cals.utils';
import { App, initStickySubnav } from '../desertland.app';
import { ROUTES } from '../desertland.router';
// import { Masonry } from '../cals.masonry';
import 'kendo-ui-core';

/* tslint:disable member-ordering */
declare var log, info, warn, group, groupCollapsed, groupEnd;

/**
 * Based on Tips, without the tabs, just an index view
 */
export class LearnmoreContent {

  public showLogs = true;

  public page = ROUTES.LEARN;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-learnmore';
  public contentContainer = "#learnmore_content_container .container";
  // public tabSel = 'learnmore_tabstrip';
  public indexSel = 'learnmore_index_container';
  public indexTransSel = 'learnmore_index_trans';
  // public footNavSel = 'learnmore_footnav_container';

  public route = '';

  public init(options, route = ROUTES.LEARN) {
    groupCollapsed("Learnmore.init");
    let showLogs = this.showLogs;

    if (showLogs) { log(this.page + ".init", options); }

    if (!options) {
      options = "";
    }
    this.route = options;

    if ($(this.container).length) {
      if (showLogs) { log("ready for " + this.page); }
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        if (showLogs) { info(this.page + " dom ready! loadTpl..."); }
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        } else {
          warn("this error!");
        }

      });
    }
    groupEnd("Learnmore.init");
  }


  public onRoute(options) {
    if (this.showLogs) { info(this.page + " > route", options); }
    if (!options) {
      options = "index";
    }
    this.route = options;
    //this.init();
    this.showRoute();
  }

  public showRoute(options = {}) {
    //info("showRoute",options);
    if (this.route) {
      if (this.showLogs) { info("there's a route", this.route); }
      let opt = this.route.split("/");
      if (this.showLogs) { info('showRoute', opt); }
      if (opt && opt.length > 0) {
        if (opt[0] === 'index') {
          this.showIndex();
        }
        // let $tab = $(".learnmore-tab-nav-" + opt[0]);
        // if ($tab.length) {
        //   this.activateTab($tab, opt[0]);

        //   if (opt.length > 1) {
        //     //info(opt[1]);
        //     let btnSel = '.btn-learnmore-' + opt[0] + '-' + opt[1];
        //     window.setTimeout(function () { // need a delay to await the tpls loaded and faded in to get good offset top #

        //       if ($(btnSel).length) {

        //         $(btnSel).click();
        //       }
        //     }, 420);

        //   }
        // }
      }
    }
  }


  public loadTpl(callback) {
    if ($(this.tplSel).length) {
      if (this.showLogs) { log("// we already have the tpl -> render"); }
      this.renderTpl({ sel: this.tplSel });
    } else {
      if (this.showLogs) { log(this.page + " > loadTpl"); }
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      if (this.showLogs) { log(this.page + " > renderContent", resp); }
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
  
        this.loadContent(this.formatThenRender);
  
      } else {
        if (this.showLogs) { info("no sel?"); }
      }
    });
  }

  public loadContent(callback) {
    if (App.data.learnmore) {
      if (this.showLogs) { log("data exists, using"); }
      this.renderContent(App.data.learnmore);
    } else {
      App.service.load.learnmore(callback);
    }
  }

  public formatThenRender = (learnmore_desc) => {
    groupCollapsed("Learnmore.Render");
    // if (this.showLogs) { info("learnmore_desc: %o learnmore: %o", learnmore_desc, learnmore); }
    if (this.showLogs) { info("learnmore_desc: %o", learnmore_desc); }
    let formatted = this.formatData(learnmore_desc);
    App.data.learnmore = formatted;
    this.renderContent(formatted);
    groupEnd("Learnmore.Render");
  }

  
  public formatData(learnmore_desc) {
    // info(learnmore, learnmore_desc);
    let catNum = 0,
      cats = [],
      learnmore_cats = {};
    
    // JUST THE INDEX (_desc)
    for (let i = 0; i < learnmore_desc.length; i++) {
      let item = learnmore_desc[i];
      if (!Utils.isEmpty(item.tid)) {
        cats.pushIfNotExist(item.tid);
        catNum++;

        learnmore_cats[item.tid] = {
          cat_name: item.learnmore_group || "",
          desc: item.learnmore_desc || "",
          cat_num: catNum,
          route: item.route,
          // items: []
        };
      }
    }


    let oRet = {
      learnmore_cats: cats,
      learnmore: learnmore_cats,
      item_count: catNum
    };

    if (this.showLogs) { info("Learnmore > formatData ret: %o", oRet); }
    return oRet;
  }

  public renderContent(data) {
    if (this.showLogs) { log("Learnmore > renderContent %o", data); }

    if ($("#learnmore.page").length && $('#'+this.indexSel).length) {
      this.renderIndex(data);
      this.addEvents();
    } else {
      info("!#learnmore.page || !container");
    }

  }

  public renderIndex(data) {
    //learnmore_index_container
    if (this.showLogs) { log("Learnmore > renderIndex %o", data); }
    let $container = $("#" + this.indexSel);//.hide().empty();

    if ($container.length && data.learnmore_cats.length > 0) {
      $container.hide().empty();

      let $row = $(document.createElement("div")).addClass('row').appendTo($container);

      for (let i = 0; i < data.learnmore_cats.length; i++) {
        this.renderIndexItem(data.learnmore[data.learnmore_cats[i]], $row);//, i + 1);
      }

      $container.fadeIn();
    }
  }

  public renderIndexItem(data, $container) {
    if (this.showLogs) { log("Learnmore > renderIndexItem %o", data); }

    let catName = Utils.changeSpacesToDashes(data.cat_name).toLowerCase();

    let tplStr = '<div class="col-sm-6">'
      // + '<div class="learnmore-cat-num-circle tips-cat-num-circle cat-num-circle circle text-center white">#= cat_num #</div>'
      + '<div class="content-nav-block bg-black-trans text-center">'
      + '<h3 class="nav-block-title">#= cat_name #</h3>'
      + '<div class="nav-block-desc">#= desc #</div>'
      // + '<div class="nav-block-action"><a href="/\\#/' + ROUTES.LEARN + '/' + catName + '" class="btn btn-outlined action__show-tab" data-tab="' + catName + '">More</a></div>'
      + '<div class="nav-block-action"><a href="/\\#/#= route #" class="btn btn-outlined action__show-tab" data-tab="' + catName + '">More</a></div>'
      + '</div>'
      + '</div>';

    let template = kendo.template(tplStr);
    let result = template(data);
    $container.append(result);

  }




  public showIndex() {
    //info("showIndex",this.indexTransSel);
    if (("#" + this.indexTransSel).length) {
      $("#" + this.indexTransSel).removeClass("minimize");
    }
    // if (("#" + this.footNavSel).length) {
    //   $("#" + this.footNavSel).addClass("minimize");
    // }
    Utils.smoothScrollTo('top');
  }


  public onClickLearnmoreTopNav() {
    // let me = App.content.Learnmore;
    if (this.showLogs) { info('topnav:click:learnmore'); }
    if (App.currentPage === this.page) {
      if (this.showLogs) { info("we're on the learnmore page"); }
      this.showIndex();
    } else {
      if (this.showLogs) { info("nada thx"); }
    }

  }

  public addEvents() {
    // let sel = '.action__show-tab',
    //   me = this;
    if (this.showLogs) { info('learnmore > addEvents'); }

    App.radio.unsubscribe('topnav:click:learnmore', this.onClickLearnmoreTopNav);
    App.radio.subscribe('topnav:click:learnmore', this.onClickLearnmoreTopNav);


    // capture external clicks to new window
    // let externalLinks = $('a[href^="http://"]:not([href^="http://desertlandscaping.arizona"]):not([href^="#"]):not([href^="/"])');
    let externalLinks = $('a[href^="http"]:not([href^="https://desertlandscaping.arizona"]):not([href^="http://localhost"])');
    //info("externalLinks len = %d els: %o",externalLinks.length,externalLinks);
    externalLinks.addClass('external').attr({
      target: "_blank",
      rel: "external"
    });

  }


  private subNavId = "";

  public loadDataTheRenderSubnav(elId) {
    this.subNavId = elId;
    if (App.data.learnmore) {
      this.renderSubNav();
    } else {
      App.service.load.learnmore(this.formatThenRenderSubNav);
    }
  }

  public formatThenRenderSubNav = (data) => {
    log('formatThenRenderSubNav', data);
    App.data.learnmore = this.formatData(data);
    this.renderSubNav();
  }

  public renderSubNav() {
    log('renderSubNav', this.subNavId);
    let data = App.data.learnmore;
    
    if (data && data.learnmore_cats && data.learnmore_cats.length > 0 && $(this.subNavId).length) {
      for (let index = 0; index < data.learnmore_cats.length; index++) {
        const item = data.learnmore[data.learnmore_cats[index]];
        log('renderSubNav item:', item);
        // <a role="button" href="#= data.siteRoot #\\#/#= data.routes.TIPS #" class="btn btn-orange btn-outline" data-bind="css:{active: isCurrentResources}">Resources</a>
        // <a role="button" href="#= data.siteRoot #\\#/#= data.routes.TIPS #" class="btn btn-orange btn-outline" data-bind="css:{active: isCurrentBibliography}">Bibliography</a>
        // <a role="button" href="#= data.siteRoot #\\#/#= data.routes.TIPS #" class="btn btn-orange btn-outline" data-bind="css:{active: isCurrentHistory}">History</a>
        // <a role="button" href="#= data.siteRoot #\\#/#= data.routes.TIPS #" class="btn btn-orange btn-outline" data-bind="css:{active: isCurrentAcknowlege}">Acknowledgements</a>
        let activeClass = (App.currentPage === item.route) ? " active" : "";

        $("<a></a>").attr({
          //'id' : btnId,
          role: 'button',
          // 'data-bind': `css:{active: isCurrentRoute('${item.route}')}`,
          href: '/#/' + item.route
        }).addClass('btn btn-orange btn-outline' + activeClass).html(item.cat_name)
        .appendTo($(this.subNavId));
        
      }
    }
  }

  


}
